import React from "react";
import imageComp from "..";

interface SNAlbumsCellProps {
  coverUrl: string;
  albumName: string;
  numberOfPhotos?: number;
  onClick: any;
}

function SNAlbumsCell({
  coverUrl,
  albumName,
  numberOfPhotos,
  onClick,
}: SNAlbumsCellProps): JSX.Element {
  let t = window.INITIAL_DATA.TRANSLATIONS;
  return (
    <imageComp.ImageCell
      isCoverImage={true}
      imageUrl={coverUrl}
      hoverElement={
        <div className={"social-upload__album"} onClick={onClick}>
          {numberOfPhotos && <p>{`${numberOfPhotos} ${t.photos}`}</p>}
          <p>{albumName}</p>
        </div>
      }
    />
  );
}

export default SNAlbumsCell;
